import React from "react";
import { Button, Flex, Grid, Icon, Type } from "mesh-component-library";
import { CheckmarkIcon, CreditCardIcon } from "mesh-icon-library";

import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { useLocale } from "../../contexts/LocaleContext";
import {getDisplayMessage} from "./helper";

const TowTransition = ({
  type,
  towCost,
  towToEnabled,
  towUnsupported,
  membership,
  onClickTowTransition,
  handleContinueWithSoftService,
  onClickCallCustomerService,
  displayCode,
  milesBased,
  dollarBased,
  towCoveredMiles,
  towCoverageAmount,
  isFerrari
}) => {
  const getTranslatedText = useLocale();

  const service = getDisplayMessage(towToEnabled, type, isFerrari);

  const hasCoverageAmount = !!towCoverageAmount && !!dollarBased;
  const hasCoverageMiles = !!towCoveredMiles && !!milesBased;
  
  return (
    <Flex
      id="continue-to-tow-content"
      direction="column"
      justifyContent="between"
      style={{
        height: `calc(100dvh - 200px)`,
      }}
      utils={{
        hrLeft: "md",
        hrRight: "md",
        vrTop: "md",
        vrBottom: "md",
      }}
    >
      <Grid
        utils={{
          noMargin: true,
          fullWidth: true,
        }}
      >
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Type element="div" align="left" size="7xl" weight="semibold" data-testid="tow-translation-title">
            {getTranslatedText(service.title)}
          </Type>
          <Type
            element="div"
            align="left"
            utils={{
              vrTop: "md",
            }}
            data-testid="tow-translation-message"
          >
            {getTranslatedText(service.message, displayCode)}
          </Type>
        </Grid.Column>

        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
          utils={{
            vrTop: "sm",
          }}
        >
          {membership && (
            <>
              <Icon icon={CheckmarkIcon} size={1.5} accent="information" />
              <Type element="div" align="center">
                {hasCoverageAmount || hasCoverageMiles ? getTranslatedText(TRANSLATION_CONSTANTS.COVERS_UPTO) : getTranslatedText(TRANSLATION_CONSTANTS.SERVICE_COVERED)}
              </Type>
              <Type
                element="div"
                align="center"
                size="3xl"
                weight="semibold"
                variant="brand"
              >
                {hasCoverageAmount && `$${towCoverageAmount}`}
                {hasCoverageMiles && `${towCoveredMiles} ${getTranslatedText(TRANSLATION_CONSTANTS.MILES)}`}
              </Type>
            </>
          )}
          {!membership && (
            <>
              <Icon icon={CreditCardIcon} size={1.5} color="coolGray-700" />
              <Type element="div" align="center">
                {getTranslatedText(TRANSLATION_CONSTANTS.STARTS_AT)}
              </Type>
              <Type
                element="div"
                align="center"
                size="3xl"
                weight="semibold"
                variant="brand"
              >
                {`$${towCost}`}
              </Type>
            </>
          )}
        </Grid.Column>
      </Grid>
      <Grid
        utils={{
          noMargin: true,
          fullWidth: true,
        }}
      >
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          {!towUnsupported ? (
            <Button
              size="lg"
              hasUpgrade
              id="continue-to-tow"
              onClick={() => onClickTowTransition()}
              utils={{
                fullWidth: true,
              }}
              data-testid="tow-translation-continueToTow-button"
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE_TO_TOW, displayCode)}
            </Button>
          ) : (
            <Button
              size="lg"
              hasUpgrade
              id="button-to-call"
              onClick={() => onClickCallCustomerService()}
              utils={{
                fullWidth: true,
              }}
              data-testid="tow-translation-callAssistance-button"
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.CALL_FOR_ASSISTANCE)}
            </Button>
          )}
          {type === "Lockout" && (
            <Button
              size="lg"
              hasUpgrade
              variant="muted"
              id="just-unlock-vehicle"
              onClick={() => handleContinueWithSoftService(false, "Lockout")}
              utils={{
                fullWidth: true,
                vrTop: "lg",
              }}
              data-testid="tow-translation-unLock-button"
            >
              {getTranslatedText(
                TRANSLATION_CONSTANTS.NO_THANKS_UNLOCK_MY_VEHICLE,
                displayCode
              )}
            </Button>
          )}
        </Grid.Column>
      </Grid>
    </Flex>
  );
};
export default TowTransition;
